const tags = {
    state: {
        tagsList: [],
    },
    mutations: {
        SET_TAGS:(state, data) => {
            state.tagsList.push(data)
        },
        delTags: (state, index) => {
            // state.tagsList
        }
    },
    actions: {
        setTags: ({ commit }, data) => {
            commit('SET_TAGS', data)
            data = []
        }
    }
  }
  
  export default tags
  


// WEBPACK FOOTER //
// ./src/store/modules/tags.js